import React, { useState, useCallback } from 'react';

/**
 * Hook for managing custom alerts
 * Usage:
 *   const { showAlert, AlertComponent } = useAlert();
 *   showAlert({ message: 'Hello', type: 'info' });
 *   showAlert({ message: 'Delete?', type: 'warning', onConfirm: () => {...} });
 */
export function useAlert() {
  const [alertState, setAlertState] = useState({
    open: false,
    title: '',
    message: '',
    type: 'info',
    onConfirm: null,
    confirmText: 'OK',
    cancelText: 'Annuler',
  });

  const showAlert = useCallback(
    ({
      title,
      message,
      type = 'info',
      onConfirm,
      confirmText = 'OK',
      cancelText = 'Annuler',
    }) => {
      setAlertState({
        open: true,
        title,
        message,
        type,
        onConfirm,
        confirmText,
        cancelText,
      });
    },
    []
  );

  const closeAlert = useCallback(() => {
    setAlertState((prev) => ({ ...prev, open: false }));
  }, []);

  const AlertComponent = () => {
    const CustomAlert =
      require('../components/CustomAlert/CustomAlert').default;
    return (
      <CustomAlert
        open={alertState.open}
        onClose={closeAlert}
        title={alertState.title}
        message={alertState.message}
        type={alertState.type}
        onConfirm={alertState.onConfirm}
        confirmText={alertState.confirmText}
        cancelText={alertState.cancelText}
      />
    );
  };

  return { showAlert, AlertComponent };
}
